<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.privacyPolicy.title')" />

    <div class="base-container-first agreement__wrapper">
      <component :is="contentComponent" />
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.contacts.orderForm.description')"
    :title="t('pages.contacts.orderForm.title')"
  />
</template>

<script lang="ts" setup>
const { locale, t } = useI18n();

const contentComponent = computed(() => {
  switch (locale.value) {
    case 'en':
      return resolveComponent('AboutPrivacyPolicyEn');
    case 'ka':
      return resolveComponent('AboutPrivacyPolicyKa');
    default:
      return resolveComponent('AboutPrivacyPolicyRu');
  }
});

useSeoMeta({
  title: t('pages.privacyPolicy.title'),
});
</script>

<style scoped>
.ui-link-secondary,
.ui-link-secondary:visited {
  color: var(--blue-1);
}

.agreement__wrapper {
  display: flex;
  flex-direction: column;
  margin: 0 auto 80px;
  padding-bottom: 0;
}

.section-headline {
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
}

@media (--desktop) {
  .agreement__wrapper {
    margin-bottom: 120px;
  }

  .section-headline {
    font-weight: 400;
    font-size: 32px;
    line-height: 1.25;
  }
}

.section {
  display: inline-grid;
  row-gap: 16px;
  margin-bottom: 40px;
}

p,
li {
  font-size: 16px;
  color: var(--grey-1);
  line-height: 1.38;
  letter-spacing: 0.05px;
}

.list-with-dots {
  padding-left: 20px;
  list-style-type: disc;
}
</style>
